import React, { useEffect, useState } from 'react';
import { IconChevronsDown } from '@rossum/ui/icons/tabler';
import {
  Box,
  IconButton,
  Paper,
  SvgIcon,
  touchRippleClasses,
} from '@rossum/ui/material';
import { borderRadius } from '@rossum/ui/theme';

type ToggleNavBarButtonProps = {
  isVisible: boolean;
  toggleVisibility: React.Dispatch<React.SetStateAction<boolean>>;
};

export const ToggleNavBarButton = ({
  isVisible,
  toggleVisibility,
}: ToggleNavBarButtonProps) => {
  const [isNearTop, setIsNearTop] = useState(false);

  useEffect(() => {
    const handleMouseMove = (event: MouseEvent) => {
      const distanceFromTop = event.clientY;
      setIsNearTop(distanceFromTop <= 75);
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <Box
      component={Paper}
      sx={{
        position: 'absolute',
        top: isVisible ? '35px' : '5px',
        lineHeight: 0,
        borderRadius: borderRadius('xl'),
        opacity: isNearTop ? 1 : 0,
        left: '50%',
        transform: 'translateX(-50%)',
        transition: 'top 0.25s, opacity 0.25s ease-in-out',
        zIndex: 11001,
      }}
    >
      <IconButton
        onClick={() => toggleVisibility(visible => !visible)}
        // Round to match the pill-shaped Paper; theme default is a rounded square.
        sx={{
          borderRadius: borderRadius('xl'),
          [`& .${touchRippleClasses.ripple} .${touchRippleClasses.child}`]: {
            borderRadius: borderRadius('xl'),
          },
        }}
      >
        <SvgIcon
          fontSize="medium"
          sx={{
            transform: isVisible ? 'scale(-1)' : 'scale(1)',
            transition: 'transform 0.25s ease-in-out',
          }}
        >
          <IconChevronsDown />
        </SvgIcon>
      </IconButton>
    </Box>
  );
};
